export function items(state) {
  return state.items;
}
export function item(state) {
  return state.item;
}
export function pagination(state) {
  return state.pagination;
}
export function orderCompleted(state) {
  return state.orderCompleted;
}